import { EntryPoint, TripType } from '../../models';
import { DateUtils } from '../../utils';

function getLocationValue(location, activeProduct) {
    if (location.geoNodeId !== 0) {
        return activeProduct === EntryPoint.TRAINS || !location.iata ? location.geoNodeId : location.iata;
    }
    return location.iata;
}

export const SegmentParams = {
    compose({ segments, tripType, activeProduct }) {
        const isMultiSegmentOneWay = tripType === TripType.ONE_WAY && segments.length > 1;
        const type = isMultiSegmentOneWay ? 'M' : tripType[0].toUpperCase();
        let url = `type=${type}`;

        if ( type!=='M' ) {
            const { origin, destination, date } = segments[0];
            const from = getLocationValue(origin, activeProduct);
            const toValue = getLocationValue(destination, activeProduct);
            const to = destination.geoNodeId !== 0 ? `;to=${toValue}` : '';
            url += `;from=${from}${to};dep=${DateUtils.formatDate(date, 'yyyy-mm-dd')}`;

            if (tripType === TripType.ROUND_TRIP && segments[1]) {
                url += `;ret=${DateUtils.formatDate(segments[1].date, 'yyyy-mm-dd')}`;
            }
        } else {
            segments.forEach(({ origin, destination, date }, i) => {
                const from = getLocationValue(origin, activeProduct);
                const to = getLocationValue(destination, activeProduct);
                url += `;from${i}=${from};to${i}=${to};dep${i}=${DateUtils.formatDate(date, 'yyyy-mm-dd')}`;
            });
        }
        return url;
    }
};
